<template>
  <div class="page">
    <a-form class="ctrl" layout="inline">
      <a-form-item>
        <a-button type="primary" @click="addCate"> 添加 </a-button>
      </a-form-item>
    </a-form>

    <div class="sec">
      <a-table
        bordered
        :dataSource="list"
        :columns="columns"
        :pagination="false"
        size="small"
        :rowKey="(record) => record.id"
      >
        <template slot="caozuo" slot-scope="text, record">
          <a-button class="button" size="small" @click="editCate(record)"
            >编辑</a-button
          >
          <a-popconfirm
            title="确定要删除吗"
            @confirm="updateStatus(record.id, 0)"
            @cancel="cancel"
            okText="确定"
            cancelText="取消"
          >
            <a-button style="margin-left: 5px" type="danger" size="small">
              删除
            </a-button>
          </a-popconfirm>
          <!-- <a-popconfirm v-if="record.status == 0" title="确定要恢复吗" @confirm="updateStatus(record.id, 1)" @cancel="cancel"
            okText="确定" cancelText="取消">
            <a-button size="small">
              恢复
            </a-button>
          </a-popconfirm> -->
        </template>
      </a-table>
    </div>

    <a-modal
      title="添加类别"
      v-model="add.show"
      @ok="doAddCate"
      @cancel="closeAddCate"
      okText="确定"
      cancelText="取消"
    >
      <a-form
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-form-item label="名称">
          <a-input v-model="add.cate_name" placeholder="请填写类别名称" />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      title="编辑类别"
      v-model="edit.show"
      @ok="doEditCate"
      @cancel="closeEditCate"
      okText="确定"
      cancelText="取消"
    >
      <a-form
        :label-col="formItemLayout.labelCol"
        :wrapper-col="formItemLayout.wrapperCol"
      >
        <a-form-item label="名称">
          <a-input v-model="edit.cate_name" placeholder="请填写类别名称" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<style lang='scss' scoped>
.sec {
  margin: 15px;
}
</style>
<script>
export default {
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 18 },
      },
      columns: [
        {
          title: "#",
          dataIndex: "id",
        },
        {
          title: "分类名称",
          dataIndex: "cate_name",
        },
        {
          title: "操作",
          dataIndex: "caozuo",
          scopedSlots: { customRender: "caozuo" },
        },
      ],
      type: null,
      list: [],
      add: {
        show: false,
        cate_name: "",
      },
      edit: {
        id: 0,
        cate_name: "",
        show: false,
      },
    };
  },
  watch: {
    "$route.query.type"() {
      console.log(this.$route.query.type);
      this.type = this.$route.query.type;
      this.getList();
    },
  },
  async created() {
    this.type = this.$route.query.type;
    this.getList();
  },
  methods: {
    cancel() {
      this.$message.error("您取消了操作");
    },
    async getList() {
      const r = await this.$axios.get("/article/getCateList?type=" + this.type);

      if (r.status == 1) {
        this.list = r.list;
      }
    },
    addCate() {
      this.add.show = true;
      this.add.type = this.type;
    },
    closeAddCate() {
      this.add = {
        show: false,
        cate_name: "",
      };
    },
    async doAddCate() {
      if (!this.add.cate_name) return this.$message.error("请填写分类名称");

      const r = await this.$axios.post("/article/doAddCate", {
        type: this.type,
        cate_name: this.add.cate_name,
      });

      if (r.status == 1) {
        this.getList();
        this.closeAddCate();
      }
    },
    async editCate(item) {
      this.edit = {
        id: item.id,
        cate_name: item.cate_name,
        show: true,
      };
    },
    closeEditCate() {
      this.edit = {
        id: 0,
        cate_name: "",
        show: false,
      };
    },
    async doEditCate() {
      const r = await this.$axios.post("/article/doEditCate", this.edit);
      if (r.status == 1) {
        this.closeEditCate();
        this.getList();
      }
    },
    async updateStatus(id, status) {
      const r = await this.$axios.post("/article/updateCateStatus", {
        id,
        status,
      });
      if (r.status == 1) {
        this.closeEditCate();
        this.getList();
      }
    },
  },
};
</script>

<style>
</style>